export default {
    anchorTarget: '_blank',
    relValue: 'noopener',
};
